var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import includes from 'lodash/includes';
import { rare } from '@shared/utils/constants';
import { Item, Lights } from './styles';
var SizeSelectItem = /** @class */ (function (_super) {
    __extends(SizeSelectItem, _super);
    function SizeSelectItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            var _a = _this.props, clickHandler = _a.clickHandler, size = _a.size;
            clickHandler(size);
        };
        return _this;
    }
    SizeSelectItem.prototype.render = function () {
        var _a = this.props, size = _a.size, active = _a.active, fitting = _a.fitting;
        return (_jsxs(Item, __assign({ onClick: this.handleClick, active: active, fitting: fitting }, { children: [_jsx(Lights, { rare: includes(rare, size.stock) }, void 0), " ", size.labelSize] }), void 0));
    };
    return SizeSelectItem;
}(Component));
export default SizeSelectItem;
